import { baseApi } from './baseApi';
import { PnLReportDto } from '../types/expense';

export const financeApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPnL: builder.query<
      PnLReportDto,
      { restaurantId: string; from: string; to: string }
    >({
      query: ({ restaurantId, from, to }) => ({
        url: `/restaurants/${restaurantId}/finance/pnl`,
        params: { from, to },
      }),
      // Single PnL cache slot per session: invalidating on expense mutations is enough,
      // and rotating ranges (Hoy / Semana / Mes) re-query with different params anyway.
      providesTags: [{ type: 'PnL' as const, id: 'CURRENT' }],
    }),
  }),
});

export const { useGetPnLQuery } = financeApi;
